export const QueryKeys = {
  ALIAS_CHANGE: 'ALIAS_CHANGE',
  FORM: 'FORM',
  EXTRA: 'EXTRA',
  EVENTS: 'EVENTS',
  CONFIG: 'CONFIG',
  WARNING: 'WARNING',
  NEWS: 'NEWS',
  USER: 'USER',
  WHO_AM_I: 'WHO_AM_I',
  RACE: 'RACE',
  FREESTYLE_RACE: 'FREESTYLE_RACE',
  RIDDLE_HINT: 'RIDDLE_HINT',
  RIDDLE_HISTORY: 'RIDDLE_HISTORY',
  RIDDLE: 'RIDDLE',
  RIDDLE_SUBMIT: 'RIDDLE_SUBMIT',
  QR_LEVELS: 'QR_LEVELS',
  BOUNTY: 'BOUNTY',
  LOCATIONS: 'LOCATIONS',
  TASK_CATEGORIES: 'TASK_CATEGORIES',
  TASK_DETAILS: 'TASK_DETAILS',
  TASK_SUBMIT: 'TASK_SUBMIT',
  TASKS_IN_CATEGORY: 'TASKS_IN_CATEGORY',
  TEAM_LIST: 'TEAM_LIST',
  TEAM_DETAILS: 'TEAM_DETAILS',
  LEADERBOARD: 'LEADERBOARD',
  KIRPAY_LEADERBOARD: 'KIRPAY_LEADERBOARD',
  TOKEN: 'TOKEN',
  COMMUNITY: 'COMMUNITY',
  ORGANIZATION: 'ORGANIZATION',
  TINDER: 'TINDER',
  TINDER_QUESTION: 'TINDER_QUESTION',
  TINDER_ANSWERS: 'TINDER_ANSWERS',
  TINDER_INTERACTION: 'TINDER_INTERACTION',
  ACCESS_KEY: 'ACCESS_KEY',
  HOME_NEWS: 'HOME_NEWS',
  DEBTS: 'DEBTS',
  GALLERY: 'GALLERY',
  HOME_GALLERY: 'HOME_GALLERY',
  SUPPORT_THREADS: 'SUPPORT_THREADS',
  SUPPORT_THREAD: 'SUPPORT_THREAD'
}
export type QueryKeys = (typeof QueryKeys)[keyof typeof QueryKeys]
